import { useEffect, useState } from "react";
import styled from "styled-components";
import Sequence from "../UI/LandingPage/Sequence";

const INTRO_DURATION_MS = 6400;

export default function FlatIntroSequence({ onExplore }) {
  const [progress, setProgress] = useState(0);
  const [showExplore, setShowExplore] = useState(false);

  useEffect(() => {
    let frameId;
    let startTime;

    const animate = (time) => {
      if (startTime == null) {
        startTime = time;
      }

      const nextProgress = Math.min((time - startTime) / INTRO_DURATION_MS, 1);
      setProgress(nextProgress);

      if (nextProgress < 1) {
        frameId = window.requestAnimationFrame(animate);
        return;
      }

      setShowExplore(true);
    };

    frameId = window.requestAnimationFrame(animate);

    return () => {
      window.cancelAnimationFrame(frameId);
    };
  }, []);

  return (
    <IntroStage>
      <Sequence count={progress} />

      <IntroOverlay>
        <div className="copy">
          <span className="eyebrow">Flat intro</span>
          <h1>Toyota Crown</h1>
          <p>
            The landing sequence now auto-plays from start to finish without
            any scroll input, so it works cleanly in a headset browser.
          </p>
        </div>

        {showExplore && (
          <button type="button" onClick={onExplore}>
            Explore
          </button>
        )}
      </IntroOverlay>
    </IntroStage>
  );
}

const IntroStage = styled.section`
  position: relative;
  height: 100vh;
  overflow: hidden;
`;

const IntroOverlay = styled.div`
  position: absolute;
  inset: 0;
  z-index: 4;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  gap: 24px;
  padding: 0 32px 42px;
  background:
    linear-gradient(180deg, rgba(0, 0, 0, 0.2) 12%, rgba(0, 0, 0, 0.72) 100%);

  .copy {
    max-width: 540px;
  }

  .eyebrow {
    display: block;
    margin-bottom: 12px;
    font-size: 0.75rem;
    letter-spacing: 0.28em;
    text-transform: uppercase;
    color: rgba(255, 255, 255, 0.7);
  }

  h1 {
    margin: 0 0 12px;
    font-size: clamp(2.8rem, 8vw, 6rem);
    line-height: 0.95;
    text-transform: uppercase;
    letter-spacing: 0.08em;
  }

  p {
    margin: 0;
    max-width: 34rem;
    font-size: 1rem;
    line-height: 1.5;
    color: rgba(255, 255, 255, 0.8);
  }

  button {
    width: fit-content;
    min-width: 180px;
    height: 52px;
    border: 0;
    border-radius: 999px;
    background: #f5f3ef;
    color: #050505;
    font-size: 0.95rem;
    font-weight: 700;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    cursor: pointer;
  }

  @media (max-width: 768px) {
    padding: 0 18px 24px;

    p {
      font-size: 0.92rem;
    }

    button {
      width: 100%;
    }
  }
`;
